export const API_MSG = {
    UNAUTHENTICATED: "USER UNAUTHENTICATED",
    UNAUTHORIZED: "USER UNAUTHORIZED",
    NOT_FOUND: "Caught 404 - URL not Found !!",
    CONNECTION: "Unable to connect to Server. Please check your Internet Connection.",
    TIME_OUT: "Request Timed out",
    UNKNOWN: "Unknown error"
}